'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import type React from 'react';
import { createContext, useContext } from 'react';
import { cn } from '../../../shared/cn';
export enum DIALOG_VARIANTS {
  DEFAULT = 'default',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}
export type DialogVariant = `${DIALOG_VARIANTS}`;
const DialogVariantContext = createContext<DialogVariant>(DIALOG_VARIANTS.DEFAULT);
export const useDialogVariant = () => {
  return useContext(DialogVariantContext);
};
export type DialogProps = Omit<Headless.DialogProps, 'className'> & {
  className?: string;
  type?: `${DIALOG_VARIANTS}`;
};
export const Dialog = t0 => {
  const $ = _c(20);
  let className;
  let props;
  let style;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      style,
      type: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = style;
    $[4] = t1;
  } else {
    className = $[1];
    props = $[2];
    style = $[3];
    t1 = $[4];
  }
  const type = t1 === undefined ? "default" : t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("fixed inset-0 z-50");
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Headless.DialogBackdrop className="fixed inset-0 backdrop-blur-xs transition-opacity" aria-hidden="true" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className) {
    t4 = cn("mx-auto w-full max-w-md overflow-hidden rounded-2xl bg-backgroundPrimary p-6 text-left align-middle shadow-xl transition-all", "border border-borderPrimary", className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props.children || $[10] !== style || $[11] !== t4 || $[12] !== type) {
    t5 = <div className="relative">{t3}<div className="fixed inset-0 overflow-y-auto"><div className="flex min-h-full items-center justify-center p-4 text-center"><Headless.DialogPanel data-variant={type} className={t4} style={style}>{props.children}</Headless.DialogPanel></div></div></div>;
    $[9] = props.children;
    $[10] = style;
    $[11] = t4;
    $[12] = type;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== props || $[15] !== t5) {
    t6 = <Headless.Dialog as="div" {...props} className={t2}>{t5}</Headless.Dialog>;
    $[14] = props;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6 || $[18] !== type) {
    t7 = <DialogVariantContext.Provider value={type}>{t6}</DialogVariantContext.Provider>;
    $[17] = t6;
    $[18] = type;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};